import { Grid, Hidden } from "@material-ui/core";
import { Fragment, useEffect } from "react";

import ShiftsReport from "./ShiftsReport";
import PumpShifts from "../PumpShifts/PumpShifts";
// import InvoiceMainTow from "../invoiceMainTow";

export default function ShiftsTypes(props) {
    const { AutoOptions, isPurches } = props;

    if (AutoOptions?.permType?.id === 4) {
        return <PumpShifts
            {...{
                AutoOptions,
                isPurches,
            }}
        />;
    } else {

        return <ShiftsReport
        {...{
          AutoOptions,
          isPurches,
        }}
      />;
      }


    

}
